export default __webpack_public_path__ + "static/media/manejebem-embrapa-logo-reduzida.a5ef2871.svg";